import type { MaybeRef, Reactive } from "vue"
import type { ServerResponse } from "@/http"
import type { IAlbumResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"
import { Album } from "@/models"

// eslint-disable-next-line unused-imports/no-unused-vars
const possibleIncludes = ["zip", "settings"] as const
type IPossibleIncludes = (typeof possibleIncludes)[number]

export interface IGetAlbumFilters {
  include?: IPossibleIncludes[]
}

export async function getAlbum(eventVaultId?: number, id?: number, queryParams: IGetAlbumFilters = {}): Promise<Album> {
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to query an album. Please ensure `eventVaultId` is provided.",
    )
  }

  if (!id) {
    throw new Error("Missing `albumId` when attempting to query an album. Please ensure `albumId` is provided.")
  }

  const query = new URLSearchParams()

  if (queryParams.include)
    query.append("include", queryParams.include?.toString())

  const endpoint = `api/event/${eventVaultId}/album/${id}?${query.toString()}`

  const response = await axios.get<ServerResponse<IAlbumResponse>>(endpoint)

  return Album.fromResponse(response.data.Data)
}

export const GET_ALBUM_QUERY_KEY = "getAlbum"

export function useGetAlbum(eventVaultId?: MaybeRef<number | undefined>, albumId?: MaybeRef<number | undefined>, filters: Reactive<IGetAlbumFilters> = {}) {
  return useQuery({
    queryKey: [GET_ALBUM_QUERY_KEY, eventVaultId, albumId, filters],
    queryFn: () => getAlbum(toValue(eventVaultId), toValue(albumId), filters),
  })
}
